(function() {
    angular
        .module("app")
        .controller("SetSpeedDisplay5x7ModalController", SetSpeedDisplay5x7ModalController)

        SetSpeedDisplay5x7ModalController.$inject = [
        "$stateParams",
        "$state",
        "$scope",
        "$uibModalInstance",
        "speedLimitTrailersService",
        "wvsl2Service",
        "userMessagingService",
        "options"
    ]

    function SetSpeedDisplay5x7ModalController(
        $stateParams,
        $state,
        $scope,
        $uibModalInstance,
        speedLimitTrailersService,
        wvsl2Service,
        userMessagingService,
        options
    ){
        "use strict"

        let maxSpeedMPH = 85
        let maxSpeedKPH = 140
        let minSpeed    = 5

        let buildImageURLs = function() {

            if ($scope.setDisplayFormData.speed === 0) {

                $scope.speedImageURL = options.baseImageURL + "Blank.png"
                $scope.beaconsImageURL = options.baseImageURL + "BeaconsOff.gif"

            } else {

                let style  = "_BW"

                if ($scope.setDisplayFormData.white_on_black) {
                    style = "_WB"
                }

                $scope.speedImageURL = options.baseImageURL + $scope.setDisplayFormData.speed + style + ".png"

                if ($scope.setDisplayFormData.beacons) {
                    $scope.beaconsImageURL = options.baseImageURL + "BeaconsOn.gif"
                } else {
                    $scope.beaconsImageURL = options.baseImageURL + "BeaconsOff.gif"
                }
            }
        }

        let setSpeed = function(speed) {

            if ($scope.usingKPH) {
                speed = Math.min(maxSpeedKPH, Math.max(5, speed))
            } else {
                speed = Math.min(maxSpeedMPH, Math.max(5, speed))
            }

            $scope.setDisplayFormData.speed = speed

            if (speed < 10 ) {
                $scope.digit2 = null
                $scope.digit3 = speed
            } else {
                $scope.digit2 = Math.floor(speed /10)
                $scope.digit3 = speed % 10
            }
            // $scope.digit2 = Math.floor(speed / 10)
            // $scope.digit3 = speed / 10 % 1 > 0 ? 5 : 0

            buildImageURLs()

        }

        let adjustDigit = function(location, increment) {

            let speed = $scope.setDisplayFormData.speed

            let maxSpeed = maxSpeedMPH

            if ($scope.usingKPH) {

                maxSpeed = maxSpeedKPH

                if (location === 1) {
                    if (increment) {
                        if (speed === maxSpeed) {
                            speed = minSpeed
                        } else if (speed >= maxSpeed - 100) {
                            speed = maxSpeed
                        } else {
                            speed = speed + 100
                        }
                    } else {
                        if (speed === minSpeed) {
                            speed = maxSpeed
                        } else if (speed <= minSpeed + 100) {
                            speed = minSpeed
                        } else {
                            speed = speed - 100
                        }
                    }
                }
            }

            if (location === 2) {
                if (increment) {
                    if (speed === maxSpeed) {
                        speed = minSpeed
                    } else if (speed >= maxSpeed - 10) {
                        speed = maxSpeed
                    } else {
                        speed = speed + 10
                    }
                } else {
                    if (speed === minSpeed) {
                        speed = maxSpeed
                    } else if (speed <= minSpeed + 10) {
                        speed = minSpeed
                    } else {
                        speed = speed - 10
                    }
                }
            }

            if (location === 3) {
                if (increment) {
                    if (speed === maxSpeed) {
                        speed = minSpeed
                    } else {
                        speed = speed + 5
                    }
                } else {
                    if (speed === minSpeed) {
                        speed = maxSpeed
                    } else {
                        speed = speed - 5
                    }
                }
            }

            setSpeed(speed)

        }

        $scope.digit1 = 0
        $scope.digit2 = 0
        $scope.digit3 = 0

        $scope.allowStyleChange = options.startDisplaySettings.allow_style_change

        if (options.messageBoardIDs) {
            $scope.isBroadcast           = true
            $scope.messageBoardIDs       = options.messageBoardIDs
            $scope.mixedUnits            = options.mixedUnits
            $scope.mixedBeacons          = options.mixedBeacons
            $scope.mixedAllowStyleChange = options.mixedAllowStyleChange
        } else {
            $scope.isBroadcast    = false
            $scope.messageBoardID = options.messageBoardID
        }

        $scope.enableBeacons = options.enableBeacons
        $scope.usingKPH      = options.startDisplaySettings.units === "KPH"

        $scope.setDisplayFormData = {
            speed:          options.startDisplaySettings.speed,
            units:          options.startDisplaySettings.units,
            white_on_black: options.startDisplaySettings.white_on_black,
            beacons:        options.startDisplaySettings.beacons,
            font_type:      "standard"
        }

        if ($scope.isBroadcast)
            gtag("event", "broadcast_message", { action: "begin", message_board_ids: $scope.messageBoardIDs })
        else
            gtag("event", "display_change", { action: "begin", device_id: options.deviceID })

        $scope.incrementDigit = function(location) {
            adjustDigit(location, true)
        }

        $scope.decrementDigit = function(location) {
            adjustDigit(location, false)
        }

        $scope.toggleStyle = function() {
            if ($scope.allowStyleChange) {
                $scope.setDisplayFormData.white_on_black = !$scope.setDisplayFormData.white_on_black
                buildImageURLs()
            }
        }

        $scope.toggleBeacons = function() {
            $scope.setDisplayFormData.beacons = !$scope.setDisplayFormData.beacons
            buildImageURLs()
        }

        $scope.setDisplay = function() {

            $scope.setDisplayFormData.beacons = $scope.enableBeacons ? $scope.setDisplayFormData.beacons : false

            let successMessage = "Set Speed Request Sent"
            let failureMessage = "Failed to Set Speed. If this issue persists, please contact Wanco Support for assistance."

            if ($scope.messageBoardIDs) {
                successMessage = "Broadcast Speed Request Sent"
                failureMessage = "Failed to Broadcast Speed. If this issue persists, please contact Wanco Support for assistance."
            }

            const setSuccess = function() {
                if ($scope.isBroadcast)
                    gtag("event", "broadcast_message", { action: "complete", message_board_ids: $scope.messageBoardIDs })
                else
                    gtag("event", "display_change", { action: "complete", device_id: options.deviceID, ...$scope.setDisplayFormData })

                userMessagingService.success(successMessage)
            }

            const setFailure = function() {
                userMessagingService.error(failureMessage)
            }

            if ($scope.messageBoardIDs) {
                $scope.setDisplayFormData.message_board_ids = $scope.messageBoardIDs
                speedLimitTrailersService.broadcastSpeedDisplay($scope.setDisplayFormData, setSuccess, setFailure)
            } else {
                console.log("WVSL2 activate ->", {
                    messageBoardID: $scope.messageBoardID,
                    formData:       $scope.setDisplayFormData
                })
                $scope.setDisplayFormData.font_type = ($scope.activeFontType === 'ohio') ? 2 : 1;
                wvsl2Service.setSpeedDisplay($scope.messageBoardID, $scope.setDisplayFormData, setSuccess, setFailure)
            }

            $uibModalInstance.close()

        }

        $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }

        // 1. Initialize the variable on the modal's scope
        $scope.activeFontType = (options.startDisplaySettings.font_type === 2) ? 'ohio' : 'standard';

        // 2. Define the toggle function on the modal's scope
        $scope.toggleFont = function() {
            $scope.activeFontType = ($scope.activeFontType === 'ohio') ? 'standard' : 'ohio';
            console.log("Modal font toggled to:", $scope.activeFontType);
        };

        $scope.cancel = function() {
            if ($scope.isBroadcast)
            gtag("event", "broadcast_message", { action: "cancel", message_board_ids: $scope.messageBoardIDs })
        else
            gtag("event", "display_change", { action: "cancel", device_id: options.deviceID })

            $uibModalInstance.dismiss('cancel');
        };

        setSpeed(options.startDisplaySettings.speed)

    }


    angular.module("app").directive('lightBoard', function() {
        return {
            restrict: 'E',
            scope: {
                value: '=',
                fontType: '=',     // Links to activeFontType in your controller
                activeColor: '=?', // Optional: defaults to Gold
                dimColor: '=?'     // Optional: defaults to Dark Grey
            },
            link: function(scope, element, attrs) {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                element[0].appendChild(canvas);

                // Configuration
                const dotSize = 6;
                const spacing = 2;
                const radius = 1;

                // Define Font Library
                const fonts = {
                    'standard': {
                        0: [0x0E, 0x11, 0x13, 0x15, 0x19, 0x11, 0x0E],
                        1: [0x04, 0x0C, 0x04, 0x04, 0x04, 0x04, 0x0E],
                        2: [0x0E, 0x11, 0x01, 0x02, 0x04, 0x08, 0x1F],
                        3: [0x1F, 0x02, 0x04, 0x02, 0x01, 0x11, 0x0E],
                        4: [0x02, 0x06, 0x0A, 0x12, 0x1F, 0x02, 0x02],
                        5: [0x1F, 0x10, 0x1E, 0x01, 0x01, 0x11, 0x0E],
                        6: [0x06, 0x08, 0x10, 0x1E, 0x11, 0x11, 0x0E],
                        7: [0x1F, 0x01, 0x02, 0x04, 0x08, 0x08, 0x08],
                        8: [0x0E, 0x11, 0x11, 0x0E, 0x11, 0x11, 0x0E],
                        9: [0x0E, 0x11, 0x11, 0x0F, 0x01, 0x02, 0x0C]
                    },
                    'ohio': {
                        0: [0x0E, 0x11, 0x11, 0x11, 0x11, 0x11, 0x0E],
                        1: [0x04, 0x0C, 0x04, 0x04, 0x04, 0x04, 0x0E],
                        2: [0x0E, 0x11, 0x01, 0x06, 0x08, 0x10, 0x1F], // From Screenshot
                        3: [0x0E, 0x11, 0x01, 0x06, 0x01, 0x11, 0x0E], // From Screenshot
                        4: [0x02, 0x06, 0x0A, 0x12, 0x1F, 0x02, 0x02],
                        5: [0x1F, 0x10, 0x1E, 0x01, 0x01, 0x11, 0x0E],
                        6: [0x06, 0x08, 0x10, 0x1E, 0x11, 0x11, 0x0E],
                        7: [0x1F, 0x01, 0x02, 0x04, 0x08, 0x08, 0x08],
                        8: [0x0E, 0x11, 0x11, 0x0E, 0x11, 0x11, 0x0E],
                        9: [0x0E, 0x11, 0x11, 0x0F, 0x01, 0x11, 0x0E]
                    }
                };

                canvas.width = (5 * dotSize) + (4 * spacing);
                canvas.height = (7 * dotSize) + (6 * spacing);

                function draw() {
                    ctx.clearRect(0, 0, canvas.width, canvas.height);

                    // 1. Determine Font Set
                    const fontSet = fonts[scope.fontType] || fonts["standard"];

                    // 2. Determine Value
                    const val = (scope.value !== null && scope.value !== undefined) ? parseInt(scope.value, 10) : -1;
                    const bitmap = (val >= 0 && val <= 9) ? fontSet[val] : [0,0,0,0,0,0,0];

                    // 3. Render Grid
                    for (let row = 0; row < 7; row++) {
                        for (let col = 0; col < 5; col++) {
                            const isOn = (val !== -1) && ((bitmap[row] >> (4 - col)) & 1);

                            const x = col * (dotSize + spacing);
                            const y = row * (dotSize + spacing);

                            // Draw the LED Square
                            ctx.beginPath();
                            ctx.roundRect(x, y, dotSize, dotSize, radius);
                            ctx.fillStyle = isOn ? (scope.activeColor || '#FFD700') : (scope.dimColor || '#1a1a1a');
                            ctx.fill();

                            // Add the "Four LED" detail inside the square ONLY if it's on
                            if (isOn) {
                                ctx.strokeStyle = 'rgba(0, 0, 0, 0.3)';
                                ctx.lineWidth = 1;
                                ctx.beginPath();
                                // Vertical divider
                                ctx.moveTo(x + dotSize / 2, y);
                                ctx.lineTo(x + dotSize / 2, y + dotSize);
                                // Horizontal divider
                                ctx.moveTo(x, y + dotSize / 2);
                                ctx.lineTo(x + dotSize, y + dotSize / 2);
                                ctx.stroke();
                            }
                        }
                    }
                }

                // Watch for changes and redraw
                scope.$watchGroup(['value', 'fontType', 'activeColor', 'dimColor'], function() {
                    draw();
                });

                // Initial draw
                draw();
            }
        };
    });

})()
